<template>
  <div>
    <v-icon :style="{ 'font-size': `${iconSize}px` }" class="text-icon-gary">icon-SITE_COST</v-icon>
    <span :style="{ 'font-size': `${fontSize}px` }" class="text-gary-date ml-2">
      {{ dataType }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    dataType: String,
    fontSize: String,
    iconSize: String
  }
}
</script>
